import usePrivateAxios from "@/common/api/usePrivateAxios"
import { Mapper } from "@/common/services/mapper";
import { useQuery } from "@tanstack/react-query";

type useEstablishmentNotificationsConfigurationsProps<T> = {
  filters?: {
    companyId?: string;
  }
  mapper?: (data: any) => T,
}

export const useEstablishmentNotificationsConfigurations = <T,>({
  filters: { companyId } = {},
  mapper = Mapper.default<T>(),
}: useEstablishmentNotificationsConfigurationsProps<T>) => {
  const privateAxios = usePrivateAxios();

  return useQuery({
    queryKey: ['establishmentCompanyNotificationConfigurations', companyId],
    queryFn: () => privateAxios.get(`/establishment/company_notification_configurations`, {
      params: {
        'company_id': companyId,
      },
    }),
    select: (data) => mapper(data?.data?.data),
  });
}
